module.exports = __webpack_public_path__ + "notSend_icon.png";